import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { StoreContext } from '../base/root-store';
import {
    Button,
    Grid,
    GridColumn,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../../../patterns';
import Progress from '../../../patterns/components/progress/progress';
import {Datapoint} from './team-results-store';
import {DistributionBars} from '../base/distributionbars/DistributionBars';

export const QuestionsHelpModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).teamResultsStore;

    const dummyData: Datapoint = {
        asked: 0,
        scorePercentage: 0,
        participationPercentage: 0,
        prepared: 0,
        answered: 0,
        distributionCounts: {
            count0: 7,
            count25: 0,
            count50: 0,
            count75: 0,
            count100: 15,
        },
    };

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.label('dashboard.questions-help-modal.title')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">{store.label('dashboard.questions-help-modal.content')}</div>
                <Grid justify={['left-xs']} className={'modal__progress-bar'}>
                    <GridColumn width={['xs-5']}>
                        <Progress
                            color="green"
                            icon="like"
                            percent={75}
                            label={store.label('dashboard.overview.score', { score_percentage: '75' })}
                        />
                    </GridColumn>
                    <GridColumn width={['xs-7']} className={'modal__chart-text'}>
                        {store.label('dashboard.category-help-modal.content-score')}
                    </GridColumn>
                </Grid>
                <Grid justify={['left-xs']} className={'modal__progress-bar'}>
                    <GridColumn width={['xs-5']}>
                        <Progress
                            color="blue"
                            icon="users"
                            percent={67}
                            label={store.label('11 of 14')}
                        />
                    </GridColumn>
                    <GridColumn width={['xs-7']} className={'modal__chart-text'}>
                        {store.label('dashboard.questions-help-modal.participation')}
                    </GridColumn>
                </Grid>
                <Grid className={'modal__progress-bar'}>
                    <GridColumn width={['xs-5']}>
                        <Button style={'filter'}
                            block={true}
                            className="custom-button"
                            iconLeft="robot-happy"
                            text={store.label('dashboard.questions.ask-mentor')}
                            color={'white'}
                        />
                    </GridColumn>
                    <GridColumn width={['xs-7']} className={'modal__chart-text'}>
                        {store.label('dashboard.questions-help-modal.mentor')}
                    </GridColumn>
                </Grid>
                <Grid justify={['left-xs']} className="modal__progress-bar">
                    <GridColumn width={['xs-5']}>
                        <div
                            style={{
                                transform: 'scale(0.9)',
                                transformOrigin: 'top left',
                            }}
                        >
                            <DistributionBars data={dummyData} />
                        </div>
                    </GridColumn>
                    <GridColumn width={['xs-7']} className="modal__chart-text">
                        {store.label('help-modal.distribution-bars')}
                    </GridColumn>
                </Grid>
                <div className="text">
                    <p className="modal__help-link-label">
                        <a href={'https://moticheck.com/kb/'} target={'_blank'} rel="noreferrer">
                            {store.label('common.help-modal.content-help-text-label')}
                        </a>
                    </p>
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['center-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('common.modal.close')} />
                        </ModalCloser>
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
